import { useEffect } from 'react';

import { organizationService } from '@organization/service/organizaion/organizationService';
import { legalEntityBranchService } from '@organization/service/legalEntityBranch/legalEntityBranchService';

export function useLoadData() {
    useEffect(() => {
        (async () => {
            await Promise.all([organizationService.load(), legalEntityBranchService.load()]);
        })();
    }, []);
}
